import { GenericValue, DynamicContent, Language } from 'hisng';
import { Publication } from 'app/fs/res/publication/model/publication';
import {
    ResearchInfrastructureUsage,
    ResearchInfrastructureOrganisation, ResearchInfrastructureEmployment
} from './research-infrastructure-classes';

export class ResearchInfrastructure extends DynamicContent {
    // attributes #################################
    id: number;
    title: string;
    description: string;

    researchInfrastructureType: GenericValue = new GenericValue();
    researchInfrastructureKind: GenericValue = new GenericValue();
    researchInfrastructureAccessKinds: GenericValue[] = [];
    publications: Publication[] = [];
    researchInfrastructureOrganisations: ResearchInfrastructureOrganisation[] = [];
    researchInfrastructureUsages: ResearchInfrastructureUsage[] = [];
    researchInfrastructureEmployments: ResearchInfrastructureEmployment[] = [];
    visibilityValue: GenericValue;
    language: Language;

    // listviews
    listviews: Record<string, any> = {};

    constructor() {
        super();
    }
}

export class SimpleResearchInfrastructure {
    id: number;
    title: string;
}
